import addDestination from './add-destination';
import addLocation from './add-location';
import formatObjectFromUrlSearchParams from './format-object-from-url-search-params';
import formatFiltersUrlSearchParams from './format-filters-url-search-params';
import removeLocation from './remove-location';
import resetAll from './reset-all';
import resetFilter from './reset-filter';
import submit from './submit';
import sync from './sync';

export default {
	addDestination,
	addLocation,
	formatFiltersUrlSearchParams,
	formatObjectFromUrlSearchParams,
	removeLocation,
	resetAll,
	resetFilter,
	submit,
	sync
};
